import { COUPON_CAMPAIGNS_VOCABULARIES } from './coupon-campaigns.js';
/** Slice d493 of the catalog (D577): the vocabularies the targeted coupon campaigns (D493) brought. */
export const SLICE_D493 = [...COUPON_CAMPAIGNS_VOCABULARIES];
//# sourceMappingURL=slice-d493.js.map